import {
  ChangelogComponentChangesItemDiv,
  ChangelogComponentHeroMainDiv,
  ChangelogComponentMainDiv,
} from "../../styles/changelogcomponentsstyles/changelogcomponentstyle";
import Footer from "../reusable/footer/footer";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";
import Logo from "./assets/bugzi logo 2.png";
import {ReactComponent as Icon} from "./assets/arrow-left-solid-full.svg"
const ChangeLogComponent = () => {
  return (
    <ChangelogComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <ChangelogComponentHeroMainDiv>
        <div>
          <div className="changelog-container">
            <div className="changelog-header-container">
              <div>
                <div>
                  <HeaderSpan text="updates" />
                </div>
              </div>
              <div>
                <div className="changelog-header-text-container">
                  <h1> Changelog</h1>
                </div>
              </div>
            </div>
            <div className="changelog-body-container">
              {data.map((item, index) => (
                <ChangelogComponentChangesItemDiv>
                  <div className="changelog-left-col">
                    <div className="">
                      <h3>August Update</h3>
                    </div>
                    <div>
                      <div className="changelog-text-wrapper ">
                        <p>Release: v1.3</p>
                      </div>
                      <div className="changelog-text-wrapper ">
                        <p>Aug 10, 2025</p>
                      </div>
                    </div>
                  </div>
                  <div className="changelog-right-col">
                    <div>
                      <div className="changelog-image-wrapper">
                        <img src={Logo} alt="" />
                      </div>
                    </div>
                    <div className="changelog-body-text-container">
                     
                       <div className="changelog-texts-container">
                        <div>
                          <div className="changelog-change-text-wrapper">
                            <h3 >ChatGPT: Better Writing</h3>
                          </div>
                        </div>
                        <div className="changelog-changes-detial-wrapper">
                            <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p>“Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                             <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p>“Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                             <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p>“Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                            
                            
                            
                        </div>
                      </div>
                      
                       <div className="changelog-texts-container">
                        <div>
                          <div className="changelog-change-text-wrapper">
                            <h3 >ChatGPT: Better Writing</h3>
                          </div>
                        </div>
                        <div className="changelog-changes-detial-wrapper">
                            <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p>“Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                             <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p>“Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                             <div className="changelog-change-detail-wrapper">
                                <div className="changelog-change-icon-wrapper">
                                    <Icon/>
                                    
                                </div>
                                <div className="changelog-change-text-wrapper">
                                    <p><b>Here comes the sun </b> “Rewrite / Shorten / Expand” in composer

 </p>
                                </div>
                            </div>
                            
                            
                            
                        </div>
                      </div>
                    </div>
                  </div>
                </ChangelogComponentChangesItemDiv>
              ))}
            </div>
          </div>
        </div>
      </ChangelogComponentHeroMainDiv>

    
      <div>
        <Footer />
      </div>
    </ChangelogComponentMainDiv>
  );
};
const data = ["", "", ""];

export default ChangeLogComponent;
